import { create } from 'zustand';
import type { Task } from '@/lib/types/task';
import type { User } from '@/lib/types/auth';

interface TaskState {
  tasks: Task[];
  addTask: (task: Task) => void;
  updateTask: (taskId: string, updates: Partial<Task>) => void;
  assignTask: (taskId: string, helper: User) => void;
}

export const useTaskStore = create<TaskState>((set) => ({
  tasks: [],
  addTask: (task) => 
    set((state) => ({ 
      tasks: [...state.tasks, task] 
    })),
  updateTask: (taskId, updates) =>
    set((state) => ({
      tasks: state.tasks.map((task) =>
        task.id === taskId ? { ...task, ...updates } : task
      ),
    })),
  assignTask: (taskId, helper) =>
    set((state) => ({
      tasks: state.tasks.map((task) =>
        task.id === taskId ? { ...task, assignedTo: helper } : task
      ),
    })),
}));